import { CustomRoleService } from "@/common/api.service"
import { FETCH_CUSTOM_ROLE, FETCH_INDIVIDUAL_CUSTOM_ROLE, ADD_CUSTOM_ROLE, UPDATE_CUSTOM_ROLE, DELETE_CUSTOM_ROLE, RESET_STATE} from "./actions.type"
import { SET_CUSTOM_ROLES, SET_INDIVIDUAL_CUSTOM_ROLE, SET_ERROR_CUSTOM_ROLE, STATE_RESET } from "./mutations.type"

const initialState = () => {
    return {
        customrole: [],
        individualcrole: [],
        croleerrors: null,
    }
}

let state = initialState()

const getters = {
    customrole(state) {
        return state.customrole
    },
    individualcrole(state) {
        return state.individualcrole
    }
}

const actions = {
    async [FETCH_CUSTOM_ROLE](context, slug) {
        const { data } = await CustomRoleService.get(slug)
        context.commit(SET_CUSTOM_ROLES, data.data)
        return data;
    },
    async [FETCH_INDIVIDUAL_CUSTOM_ROLE](context, slug) {
        const { data } = await CustomRoleService.get(slug)
        context.commit(SET_INDIVIDUAL_CUSTOM_ROLE, data.data)
        return data;
    },  
    async [ADD_CUSTOM_ROLE](context, payload) {
        return await CustomRoleService.create(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_CUSTOM_ROLE, error.response.data.errors)
        });
    },     
    async [UPDATE_CUSTOM_ROLE](context, payload) {
        return await CustomRoleService.update(payload, payload.custom_role_id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_CUSTOM_ROLE, error.response.data.errors)
        });
    },  
    async [DELETE_CUSTOM_ROLE] (context, id) {
        return await CustomRoleService.delete(id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_CUSTOM_ROLE, error.response.data.errors)
        });
    },  
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {     
    [SET_CUSTOM_ROLES](state, data) {
        state.customrole = data
    },
    [SET_INDIVIDUAL_CUSTOM_ROLE](state, individualcrole) {
        state.individualcrole = individualcrole
    },  
    [SET_ERROR_CUSTOM_ROLE](state, error) {
        state.croleerrors = error
    },
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    } 
};

export default {
    state,
    getters,
    actions,
    mutations
};